
const Dashboard = ()=>{

    return (
    <div class="main-content">
        <div class="page-content">
            <div class="container-fluid"></div>
        </div>
    </div>
    );
}
export default Dashboard;